/**
 * Resolves the base URL of the customer-facing web app (hangarmax.com) for admin deep-links,
 * e.g. the read-only 3D preview at `/app/admin/preview/:layoutId`.
 *
 * Priority:
 *  1. `VITE_WEB_APP_URL` build env — explicit override (e.g. a staging host). Trailing slash trimmed.
 *  2. Derived from the admin's own origin in prod: any `*.hangarmax.com` host → `https://hangarmax.com`.
 *  3. Dev fallback: `http://localhost:5180` (the web app's reserved dev port — see scripts/lib/devPorts.mjs).
 *
 * The origin-derivation (2) is what makes the button work in production even when the CF Pages
 * `VITE_WEB_APP_URL` build var is unset — which is exactly the bug that made it fall back to localhost.
 */
export function resolveWebAppUrl(
  env: string | undefined = import.meta.env.VITE_WEB_APP_URL as string | undefined,
  hostname: string | undefined = typeof window !== 'undefined' ? window.location.hostname : undefined,
): string {
  if (env) return env.replace(/\/$/, '')
  if (hostname?.endsWith('hangarmax.com')) return 'https://hangarmax.com'
  return 'http://localhost:5180'
}
